<template>
  <Modal
    theme="dark"
    width="95%"
    :show="show"
    :stopEvent="true"
    :maxWidth="maxWidth"
    @close="onClose"
  >
    <div class="modal-plus">
      <h3 class="modal-plus-heading">{{ title }}</h3>
      <div>
        <slot></slot>
      </div>
      <div v-if="withButtons" class="modal-plus-buttons">
        <button v-if="showButtons.cancel" class="modal-plus-buttons-cancel" @click="onClose">
          Cancel
        </button>
        <button
          v-if="showButtons.proceed"
          class="modal-plus-buttons-proceed"
          @click="onProceed"
          :disabled="disabled || loading"
        >
          <BeatLoader
            v-if="loading"
            color="#FAFAFA"
            :size="0.875"
            sizeUnit="rem"
            class="flex items-center"
          />
          <span v-else>{{ buttonText }}</span>
        </button>
      </div>
      <span @click="onClose" class="modal-plus-close">
        <VSvgIcon name="close" class="h-5 font-bold text-gray-600" />
      </span>
    </div>
  </Modal>
</template>

<script>
import { BeatLoader } from '@saeris/vue-spinners';
import VSvgIcon from '@/components/base/VSvgIcon';
import Modal from './Modal';

export default {
  name: 'ModalPlus',
  components: { BeatLoader, VSvgIcon, Modal },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    withButtons: {
      type: Boolean,
      required: false,
      default: true,
    },
    showButtons: {
      type: Object,
      required: false,
      default: () => ({ cancel: true, proceed: true }),
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Save',
    },
    show: {
      type: Boolean,
      required: true,
    },
    onClose: {
      type: Function,
      required: false,
      default: () => {},
    },
    onProceed: {
      type: Function,
      required: false,
      default: () => {},
    },
    maxWidth: {
      type: String,
      required: false,
      default: '700px',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
